import React from 'react'
import './styles.scss'
interface Props {
  dir: 'up' | 'right'
  pos: number[]
  text: string
}

export const AxisLabel = ({ dir, pos, text }: Props) => {
  const arrows = {
    up: [
      [0, 5],
      [5, 0],
      [10, 5],
      [5, 0],
      [5, 10]
    ],
    right: [
      [5, 0],
      [10, 5],
      [5, 10],
      [10, 5],
      [0, 5]
    ]
  }
  return (
    <g transform={'translate(' + pos[0] + ',' + pos[1] + ')'}>
      <text x={15} y={10} className='tick'>
        {text}
      </text>
      <polyline
        points={arrows[dir].map(m => m.join(',')).join(' ')}
        className='arrow'
      />
    </g>
  )
}
